<div class="page-container">
  <div class="scrollable-content">
    <header class="onboarding-header p-lg">
      <h1 class="m-0" data-testid="onboarding-heading">{{ 'onboarding.title' | translate }}</h1>
      <p class="subtitle">{{ 'onboarding.subtitle' | translate }}</p>
    </header>

    @if (loading()) {
      <div class="flex flex-column flex-align-center p-xl">
        <app-spinner />
      </div>
    } @else {
      @if (!canSetUp()) {
        <p class="no-permission m-lg p-md" data-testid="onboarding-no-permission">
          {{ 'onboarding.noPermission' | translate }}
        </p>
      }

      <div class="scenario-grid px-lg">
        @for (card of cards(); track card.def.id) {
          <article
            class="scenario-card flex flex-column gap-md p-lg"
            [class.installed]="card.installed"
            [attr.data-testid]="'scenario-card-' + card.def.id"
          >
            <div class="flex flex-align-center gap-md">
              <span class="scenario-icon flex flex-align-center">
                <app-icon [name]="card.def.icon" [size]="28" />
              </span>
              <h2 class="scenario-title m-0">{{ card.def.titleKey | translate }}</h2>
            </div>

            <p class="m-0">{{ card.def.descriptionKey | translate }}</p>

            <ul class="scenario-highlights m-0">
              @for (key of card.def.highlightKeys; track key) {
                <li>{{ key | translate }}</li>
              }
            </ul>

            @if (card.installed) {
              <p
                class="scenario-status flex flex-align-center gap-sm m-0"
                [attr.data-testid]="'scenario-installed-' + card.def.id"
              >
                <app-icon name="check-circle" [size]="16" />
                {{ 'onboarding.installed' | translate: removeParams(card) }}
              </p>
            }

            <div class="scenario-actions flex flex-wrap gap-sm">
              @if (confirmingRemove() === card.def.id) {
                <div
                  class="confirm-remove flex flex-column gap-sm p-md"
                  [attr.data-testid]="'scenario-remove-confirm-' + card.def.id"
                >
                  <span>{{ 'onboarding.removeConfirm' | translate: removeParams(card) }}</span>
                  <div class="flex gap-sm flex-wrap">
                    <app-button
                      variant="filled"
                      color="danger"
                      (click)="confirmRemove(card.def.id)"
                      [disabled]="busy() !== null"
                      [attr.data-testid]="'scenario-remove-yes-' + card.def.id"
                    >
                      <app-icon name="trash-2" />
                      {{ 'onboarding.removeYes' | translate }}
                    </app-button>
                    <app-button
                      variant="outlined"
                      (click)="cancelRemove()"
                      [disabled]="busy() !== null"
                      [attr.data-testid]="'scenario-remove-no-' + card.def.id"
                    >
                      {{ 'button.cancel' | translate }}
                    </app-button>
                  </div>
                </div>
              } @else if (card.installed) {
                <app-button
                  variant="filled"
                  (click)="startTour(card.def.id)"
                  [disabled]="busy() !== null"
                  [attr.data-testid]="'scenario-tour-' + card.def.id"
                >
                  <app-icon name="compass" />
                  {{ 'onboarding.startTour' | translate }}
                </app-button>
                @if (canSetUp()) {
                  <app-button
                    variant="outlined"
                    (click)="askRemove(card.def.id)"
                    [disabled]="busy() !== null"
                    [attr.data-testid]="'scenario-remove-' + card.def.id"
                  >
                    <app-icon name="trash-2" />
                    {{ 'onboarding.remove' | translate }}
                  </app-button>
                }
              } @else {
                <app-button
                  variant="filled"
                  (click)="tryScenario(card.def.id)"
                  [disabled]="busy() !== null || !canSetUp()"
                  [attr.data-testid]="'scenario-try-' + card.def.id"
                >
                  @if (busy() === card.def.id) {
                    <app-spinner [diameter]="18" />
                  } @else {
                    <app-icon name="play" />
                  }
                  {{ 'onboarding.try' | translate }}
                </app-button>
              }
            </div>
          </article>
        }
      </div>

      <footer class="onboarding-footer flex flex-wrap flex-align-center gap-md p-lg">
        <span class="mr-auto">{{ 'onboarding.scratchPrompt' | translate }}</span>
        <app-button
          variant="outlined"
          (click)="startFromScratch()"
          [disabled]="!canSetUp()"
          data-testid="onboarding-action-create-form"
        >
          <app-icon name="plus" />
          {{ 'onboarding.scratch' | translate }}
        </app-button>
        <app-button variant="text" (click)="skipOnboarding()" data-testid="onboarding-skip-btn">
          {{ 'onboarding.skip' | translate }}
        </app-button>
      </footer>
    }
  </div>
</div>
